module.exports = __webpack_public_path__ + "img/pdfLogo.3d84b0c2.png";